'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minorScale = _theme2.default.minorScale;


var ValidationMessageLine = function ValidationMessageLine(props) {
  return _react2.default.createElement(_Box2.default, _extends({}, (0, _glamor.css)({
    borderBottom: '1px solid ' + _theme2.default.colors.borderColor,
    borderLeft: '1px solid ' + _theme2.default.colors.borderColor,
    borderBottomLeftRadius: _theme2.default.borderRadius[0]
  }), props));
};

ValidationMessageLine.defaultProps = {
  width: '8px',
  height: '10px',
  display: 'inline-block',
  position: 'relative',
  marginLeft: 2,
  top: '-3px',
  marginRight: 1
};

ValidationMessageLine.displayName = 'ValidationMessageLine';

var ValidationMessage = function ValidationMessage(props) {
  return _react2.default.createElement(
    _Box2.default,
    { position: 'relative' },
    _react2.default.createElement(ValidationMessageLine, null),
    _react2.default.createElement(_Text2.default, props)
  );
};

ValidationMessage.defaultProps = {
  textStyle: 'body2',
  display: 'inline-block',
  paddingTop: minorScale(1),
  muted: 2
};

ValidationMessage.displayName = 'ValidationMessage';

exports.default = ValidationMessage;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/ValidationMessage.js
// module id = 1137
// module chunks = 0